module.exports = "/fonts/vendor/boxicons/boxicons.woff?d12afc36557395143e4b7f5bd3d60ae6";